import "chart.js/auto";
import cx from "classnames";
import IconButton from "components/Shared/IconButton";
import ArrowRight from "icons/ArrowRight";
import CheckCircle from "icons/CheckCircle";
import { NavExpense } from "icons/NavExpense";
import { NavOfferings2 } from "icons/NavOfferings2";
import { NavOrder } from "icons/NavOrder";
import { NavProduct } from "icons/NavProduct";
import { NavSale } from "icons/NavSale";
import { NavStore } from "icons/NavStore";
import Rocket from "icons/Rocket";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { OnboardingAction } from "types";

export const OnboardingActions = ({
  actionsLeft,
  onboardingActions
}: {
  actionsLeft: number;
  onboardingActions: OnboardingAction[];
}) => {
  const [hideCheckList, setHideCheckList] = useState(false);
  const mapping = {
    CREATE_PRODUCT: {
      icon: <NavProduct />,
      text: "Add your products",
      link: "/products?new"
    },
    CREATE_OFFERING: {
      icon: <NavOfferings2 />,
      text: "Add the offerings on your menus",
      link: "/sales/offerings/create"
    },
    RECORD_STORE_ITEM_STOCK: {
      icon: <NavStore />,
      text: "Update store with current purchase prices",
      link: "/store?purchase"
    },
    CREATE_EXPENSE: {
      icon: <NavExpense />,
      text: "Record your business expenses",
      link: "/expenses/create"
    },
    CREATE_ORDER: {
      icon: <NavSale />,
      text: "Create your first order",
      link: "/sales/orders/create"
    }
  };
  const requiredActions = onboardingActions.filter((action) => action.isRequired);
  return (
    <div className="space-y-4 mb-8">
      <div className="w-full text-white rounded-lg bg-gradient-to-r from-primary to-secondary p-3 md:p-6 md:py-5 flex justify-between gap-x-4">
        <div className="w-10 pr-2 md:pr-0 md:w-20 flex-none">
          <Rocket className="" />
        </div>
        <div className="flex-grow">
          <p className="font-bold pb-2 text-xl md:text-3xl">You are almost set!</p>
          <p className="text-lg">
            Please complete all the items on the onboarding checklist. This will help your business
            get setup to tracking finances
          </p>
          <div className="flex flex-wrap gap-x-2 md:gap-x-4 items-center">
            <p className="text-lg font-bold">{actionsLeft} items left</p>
            <span className="my-2 md:my-4">
              <IconButton onClick={() => setHideCheckList((prev) => !prev)} icon={<CheckCircle />}>
                {hideCheckList ? "Show" : "Hide"} checklist
              </IconButton>
            </span>
          </div>
        </div>
      </div>
      {!hideCheckList && (
        <div className="w-full rounded-lg bg-white p-3 md:p-6 md:py-5 flex flex-col items-center">
          <p className="text-xl font-bold text-center text-dark-grey mt-4 mb-8">
            Almost there, {requiredActions.length - actionsLeft} of {requiredActions.length}{" "}
            completed
          </p>
          <div className="w-full md:w-[600px] md:pb-8">
            {Object.keys(mapping).map((key) => {
              const action = onboardingActions.find((action) => action.id == key);
              if (!action?.isRequired) return null;
              return (
                <div className="flex py-4 border-b-2 border-soft-grey items-center" key={key}>
                  <span
                    className={cx(
                      "pl-2 pr-4",
                      action?.completed ? "text-grey-50" : "text-primary"
                    )}>
                    {mapping[key as keyof typeof mapping].icon}
                  </span>
                  <p
                    className={cx("flex-1 font-bold text-lg", action?.completed && "text-grey-50")}>
                    {mapping[key as keyof typeof mapping].text}
                  </p>
                  <Link to={mapping[key as keyof typeof mapping].link}>
                    {action?.completed ? <CheckCircle className="text-primary" /> : <ArrowRight />}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
